module.exports = __webpack_public_path__ + "img/pay-now.60a3b907.png";